module.exports = __webpack_public_path__ + "media/src/public/img/saveme_qr_sber-e0846dfc07a6ffd3f6d922d4ee7e9177.png";